import React from "react"

const styleSheet = theme => ({
  root: {
    padding: [theme.spacing.unit * 3, theme.spacing.unit * 2, theme.spacing.unit],

    "&:last-child": {
      paddingBottom: theme.spacing.unit * 3,
    },
  },
})

class ComponentErrorMessage extends React.Component {
  shouldComponentUpdate({ children }) {
    return !!children
  }

  render() {
    const {
      classes,
      children,

      ...otherProps
    } = this.props

    return (
      <div {...otherProps} className={classes.root}>
        {children}
      </div>
    )
  }
}

import withStyles from "@material-ui/core/styles/withStyles"
export default withStyles(styleSheet)(ComponentErrorMessage)



// WEBPACK FOOTER //
// ../ui-kit/src/components/ui-ComponentError/ComponentErrorMessage.js